import { render, staticRenderFns } from "./NewMessageTip.vue?vue&type=template&id=4e022244&scoped=true&"
import script from "./NewMessageTip.vue?vue&type=script&lang=js&"
export * from "./NewMessageTip.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageTip.vue?vue&type=style&index=0&id=4e022244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e022244",
  null
  
)

export default component.exports